<div class="apps-book-widget-desktop">
  <div class="apps-book-widget-desktop__left-container">
    <div class="left-container-row-1">
      <div class="left-container-row-1__item airports-field">
        <idp-one-way-route-picker
          [routePickerContent]="{
            origin: {
              title:
                bookWidgetFields.airportsField.airports[0].fromAirportcode ||
                bookWidgetAem.airportsField.from,
              subtitle:
                bookWidgetFields.airportsField.airports[0].fromCity ||
                bookWidgetAem.airportsField.yourOrigin
            },
            destination: {
              title:
                bookWidgetFields.airportsField.airports[0].toAirportcode ||
                bookWidgetAem.airportsField.to,
              subtitle:
                bookWidgetFields.airportsField.airports[0].toCity ||
                bookWidgetAem.airportsField.yourDestination
            },
            ariaLabels: {
              origin:
                bookWidgetAem.airportsField.originAriaLabel +
                (bookWidgetFields.airportsField.airports[0].fromAirportcode
                  .length
                  ? ' ' +
                    bookWidgetFields.airportsField.airports[0].fromAirportcode +
                    ', ' +
                    bookWidgetFields.airportsField.airports[0].fromCity
                  : ''),
              swapArrow: bookWidgetAem.airportsField.swapAriaLabel,
              destination:
                bookWidgetAem.airportsField.destinationAriaLabel +
                (bookWidgetFields.airportsField.airports[0].toAirportcode.length
                  ? ' ' +
                    bookWidgetFields.airportsField.airports[0].toAirportcode +
                    ', ' +
                    bookWidgetFields.airportsField.airports[0].toCity
                  : '')
            }
          }"
          [routePickerCities]="{
            destinationCode:
              bookWidgetFields.airportsField.airports[0].toAirportcode,
            destinationName: bookWidgetFields.airportsField.airports[0].toCity,
            destinationRegion: '',
            originCode:
              bookWidgetFields.airportsField.airports[0].fromAirportcode,
            originName: bookWidgetFields.airportsField.airports[0].fromCity,
            originRegion: ''
          }"
          [routePickerError]="
            bookWidgetFields.airportsField.fieldErrorInfo?.routePickerField
          "
          [recentSearchList]="recentSearchList"
          [savedSearchList]="savedSearchList"
          [searchModalTabs]="searchModalTabs"
          [isFullscreen]="isFullscreen"
          [predictiveSearchData]="predictiveSearchData"
          (swapClicked)="swapClicked.emit(0)"
          (searchModalTriggerClicked)="searchModalTriggerClicked.emit($event)"
          (searchModalEvent)="searchModalEvent.emit($event)"
        ></idp-one-way-route-picker>
      </div>
      <div class="left-container-row-1__item trip-type-field">
        <mach-select
          id="trip-type-field"
          [title]="''"
          [content]="bookWidgetFields.tripTypesField.dropdownOptions"
          [disabled]="bookWidgetFields.tripTypesField.disable"
          (action)="
            onDropdownSelectionChange(
              $event,
              bookWidgetFieldUpdateTypes.tripType
            )
          "
          [icon]="{
            alt: '',
            src:
              bookWidgetFields.tripTypesField.selectedTripType ===
              tripTypeOptions.ONE_WAY
                ? '/content/dam/delta-applications/sitewide/capability/flight-shop/images/one-way.svg'
                : '/content/dam/delta-applications/sitewide/capability/flight-shop/images/trip-icon.svg',
            show: true
          }"
          [ariaLabel]="bookWidgetAem.tripTypesField.tripTypeAriaLabel"
        ></mach-select>
      </div>
      <div class="left-container-row-1__item dates-field">
        <idp-flight-date-picker
          [selectedTripType]="bookWidgetFields.tripTypesField.selectedTripType"
          [selectedRange]="bookWidgetFields.datesField.dates[0]"
          [bookWidgetAem]="bookWidgetAem"
          [datepickerConfig]="datepickerConfig"
          [fieldErrorInfo]="bookWidgetFields.datesField.fieldErrorInfo?.[0]"
          (action)="
            onDateSelectionChange(
              $event,
              bookWidgetFieldUpdateTypes.datesChange,
              0
            )
          "
        ></idp-flight-date-picker>
      </div>
      <div class="left-container-row-1__item passenger-field">
        <mach-select
          [title]="''"
          [content]="bookWidgetFields.passengerField.dropdownOptions"
          [disabled]="bookWidgetFields.passengerField.disable"
          (action)="
            onDropdownSelectionChange(
              $event,
              bookWidgetFieldUpdateTypes.passenger
            )
          "
          [valueAsLabel]="true"
          [icon]="{
            alt: bookWidgetAem.passengerField.passenger,
            src: '/content/dam/delta-applications/sitewide/capability/flight-shop/images/pax-icon.svg',
            show: true
          }"
          [id]="'apps-pax-dropdown-desktop-ow-rt'"
          [ariaLabel]="bookWidgetAem.passengerField.passengerAriaLabel"
        ></mach-select>
      </div>
    </div>
    <div class="left-container-row-2">
      <div
        class="left-container-row-2__item shop-miles-field"
        *ngIf="!bookWidgetFields.shopMilesField.hide"
      >
        <input
          machCheckbox
          type="checkbox"
          id="shopWithMiles"
          [disabled]="bookWidgetFields.shopMilesField.disable"
          [attr.aria-label]="bookWidgetAem.shopMilesField.shopWithMiles"
          [checked]="bookWidgetFields.shopMilesField.checked"
          [disabled]="bookWidgetFields.shopMilesField.disable"
          (change)="
            onCheckBoxChange($event, bookWidgetFieldUpdateTypes.shopMiles)
          "
        />
        <label for="shopWithMiles" class="field-label">
          {{ bookWidgetAem.shopMilesField.shopWithMiles }}
        </label>
      </div>
      <div
        class="left-container-row-2__item flex-dates-field"
        *ngIf="!bookWidgetFields.flexDatesField.hide"
      >
        <input
          machCheckbox
          type="checkbox"
          id="flexibleDate"
          [checked]="bookWidgetFields.flexDatesField.checked"
          [disabled]="bookWidgetFields.flexDatesField.disable"
          (change)="
            onCheckBoxChange($event, bookWidgetFieldUpdateTypes.flexDates)
          "
        />
        <label for="flexibleDate" class="field-label">
          {{ bookWidgetAem.flexDatesField.flexDates }}
        </label>
      </div>
      <div
        class="left-container-row-2__item basic-fares-field"
        *ngIf="!bookWidgetFields.basicFaresField.hide"
      >
        <input
          machCheckbox
          type="checkbox"
          id="basicFaresField"
          [checked]="bookWidgetFields.basicFaresField.checked"
          [disabled]="bookWidgetFields.basicFaresField.disable"
          (change)="
            onCheckBoxChange($event, bookWidgetFieldUpdateTypes.basicFares)
          "
        />
        <label for="basicFaresField" class="field-label">
          {{ bookWidgetAem.includeBasicField.includeBasic }}
        </label>
      </div>
      <div
        class="left-container-row-2__item refundable-fare-field"
        *ngIf="!bookWidgetFields.refundableFareField.hide"
      >
        <img
          src="/content/dam/delta-applications/sitewide/capability/flight-shop/images/alert-icon-help.svg"
          [attr.aria-label]="
            bookWidgetAem.refundableFareField.refundableOnly +
            ' ' +
            bookWidgetAem.helpIconAriaLabel
          "
          role="button"
          tabindex="0"
          (click)="
            infoIconClickHandler(bookWidgetFieldInfoTypes.REFUNDABLE_FARE_ONLY)
          "
          (keypress)="
            $event.key === 'Enter' &&
              infoIconClickHandler(
                bookWidgetFieldInfoTypes.REFUNDABLE_FARE_ONLY
              )
          "
        />
        <label for="showExtraFareOnly" class="field-label">
          {{ bookWidgetAem.refundableFareField.refundableOnly }}
        </label>
        <input
          machCheckbox
          type="checkbox"
          id="showExtraFareOnly"
          [disabled]="bookWidgetFields.refundableFareField.disable"
          [checked]="bookWidgetFields.refundableFareField.checked"
          (change)="
            onCheckBoxChange($event, bookWidgetFieldUpdateTypes.refundableFare)
          "
        />
      </div>
      <div
        class="left-container-row-2__item flex-airports-field"
        *ngIf="!bookWidgetFields.flexAirportsField.hide"
      >
        <input
          machCheckbox
          type="checkbox"
          id="includeNearByAirport"
          [checked]="bookWidgetFields.flexAirportsField.checked"
          [disabled]="bookWidgetFields.flexAirportsField.disable"
          (change)="
            onCheckBoxChange($event, bookWidgetFieldUpdateTypes.flexAirport)
          "
        />
        <label for="includeNearByAirport" class="field-label">
          {{ bookWidgetAem.flexAirportsField.flexAirports }}
        </label>
      </div>
      <div class="left-container-row-2__item best-fare-meeting-container">
        <div
          class="best-fare-options-field"
          *ngIf="!bookWidgetFields.bestFareOptionsField.hide"
        >
          <idp-best-fare-options
            [bookWidgetAem]="bookWidgetAem"
            [bookWidgetFields]="bookWidgetFields"
            (bestFareOptionsChange)="
              onDropdownSelectionChange(
                $event,
                bookWidgetFieldUpdateTypes.bestFareOptions
              )
            "
          ></idp-best-fare-options>
        </div>
        <div
          class="meeting-event-code-field"
          *ngIf="!bookWidgetFields.meetingEventCodeField.hide"
        >
          <idp-meeting-event-code
            [bookWidgetAem]="bookWidgetAem"
            [bookWidgetFields]="bookWidgetFields"
            (meetingEventCodeChange)="
              onInputFieldChange(
                $event,
                bookWidgetFieldUpdateTypes.meetingEventCode
              )
            "
          ></idp-meeting-event-code>
        </div>
      </div>
    </div>
    <div class="left-container-row-3">
      <a
        class="left-container-row-3__item edocs-link"
        *ngIf="!bookWidgetFields.edocsLink.hide"
        machLink
        [href]="bookWidgetFields.edocsLink.src"
        [linkSize]="'medium'"
        [linkDisabled]="bookWidgetFields.edocsLink.disable"
        [innerHTML]="bookWidgetAem.edocsLink"
      ></a>
      <div class="left-container-row-3__item find-flights-btn-small-desktop">
        <ng-container *ngTemplateOutlet="findFlightsBtnTemplate"></ng-container>
      </div>
    </div>
  </div>
  <div class="apps-book-widget-desktop__right-container">
    <ng-container *ngTemplateOutlet="findFlightsBtnTemplate"></ng-container>
  </div>

  <ng-template #findFlightsBtnTemplate>
    <button
      id="findFilghtsCta"
      machButton
      [buttonSize]="'large'"
      [buttonColor]="'primary'"
      [buttonOutlineColor]="'primary'"
      (click)="findFlightSubmit()"
    >
      {{ bookWidgetAem.searchBtn }}
    </button>
  </ng-template>
</div>
